import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SettingRepository } from "./setting.repository";

@NgModule({
  declarations: [],
  imports: [CommonModule],
  exports: [],
  providers: [SettingRepository],
})
export class SettingDomainModule {}
